import { FiPlay } from 'react-icons/fi';

export default function RunNowButton({ onClick }) {
  return (
    <button onClick={onClick}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-[11px] font-semibold text-white bg-blue-600 hover:bg-blue-700">
      <FiPlay className="h-3.5 w-3.5" />
      Vérifier maintenant
    </button>
  );
}
